<div class="top-nav">
    <button matButton="outlined" class="top-nav-button" routerLink="" routerLinkActive="">Projektübersicht</button>
<!--    <button matButton="outlined" class="top-nav-button" routerLink="/qs/check/1">Ausgewählte Kontrolle</button>-->
</div>
